import { Paper, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'


const VideoUrlCard = (props) => {
    return (
        <>
            <Paper elevation={0} className={`${props?.value ? "approvePaper urlPaper" : "urlPaper"}`}>
                <Box className="urlCardItems">
                    <Typography variant='h5'>Video URL:</Typography>
                    <Typography variant='body1'>{props?.videoLink}</Typography>
                </Box>
                <Box className="urlCardItems">
                    <Typography variant='h5'>Notes:</Typography>
                    <Typography variant='body1'>{props?.noteText}</Typography>
                </Box>
                <Box className="urlCardItems">
                    <Typography variant='h5'>Decision: <span>{props?.dicision}</span></Typography>
                </Box>
            </Paper>
        </>
    )
}

export default VideoUrlCard